module.exports = __webpack_public_path__ + "img/make_icon.76ecc628.jpg";